import { getSessionToken } from "../auth/sessionToken";
import { requestRecentVerification } from "../auth/recentVerification";
import API_BASE_URL from "./api";

const originalFetch = window.fetch.bind(window);
const apiOrigin = new URL(API_BASE_URL, window.location.origin).origin;
const deviceId = localStorage.getItem("akkorent_device_id") || window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
localStorage.setItem("akkorent_device_id", deviceId);

window.fetch = async (input, init = {}) => {
  const url = new URL(typeof input === "string" ? input : input.url, window.location.origin);
  const isApiRequest = url.origin === apiOrigin && url.pathname.startsWith("/api");
  const retryInput = input instanceof Request ? input.clone() : input;

  const send = async (requestInput) => {
    const headers = new Headers(init.headers || (requestInput instanceof Request ? requestInput.headers : undefined));

    if (isApiRequest) {
      const token = await getSessionToken();
      if (token) headers.set("Authorization", `Bearer ${token}`);
      headers.set("X-Client-Timezone", Intl.DateTimeFormat().resolvedOptions().timeZone || "");
      headers.set("X-Device-ID", deviceId);
    }
    return originalFetch(requestInput, { ...init, headers });
  };

  const response = await send(input);
  if (!isApiRequest || response.status !== 403) return response;

  const body = await response.clone().json().catch(() => ({}));
  if (body.error !== "recent_authentication_required") return response;

  const verified = await requestRecentVerification(body.action || "continue");
  return verified ? send(retryInput) : response;
};
